import alt from '../alt'
import { get } from '../core/HttpClient'
import moment from 'moment'


class MessageActions {
  constructor () {
    this.generateActions(
      'fetchedMessages'
    )
  }

  fetchMessages () {
    return (dispatch) => {
      dispatch()

      const date = moment().format('Y-MM-DDTHH:mm:ssZ')

      get('/status-messages/search?dateTime=' + encodeURIComponent(date), {})
        .then(res => {
          if (res) {
            this.fetchedMessages(res)
          }
        })
        .catch(err => console.log('MessageActions.fetchMessages.err', err))
    }
  }

}

export default alt.createActions(MessageActions)
